import { render, staticRenderFns } from "./FormJobStatusOnboarding.vue?vue&type=template&id=5d67e0fd&"
import script from "./FormJobStatusOnboarding.vue?vue&type=script&lang=js&"
export * from "./FormJobStatusOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./FormJobStatusOnboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports